<div class="header-wrapper" xmlns="http://www.w3.org/1999/html">
  <app-language-switcher class="absolute"></app-language-switcher>
  <div class="w-100 flex justify-content-center">
    <img class="inline md:hidden" src="../../../../assets/images/logo-sm.svg" alt="PayMe logo" />
  </div>
</div>
<div class="background">
  <div class="right-circle"></div>
  <div class="left-circle"></div>
</div>
<div class="content-wrapper" [dir]="direction$ | async">
  <ng-content></ng-content>
</div>
<app-loader></app-loader>
